import Articles from "../components/articles/Articles";
import Contact from "../components/contact/Contact";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Hero from "../components/hero/Hero";
import Projects from "../components/projects/Projects";
import { Container } from "./Home.Elements";

const Home = () => {
  return (
    <>
      <Container>
        <Header view='portfolio' />
        <Hero />
        <Projects />
        <Articles />
        <Contact />
      </Container>

      <div style={{ backgroundColor: "#2f3133", color: "white" }}>
        <Footer />
      </div>
    </>
  );
};

export default Home;
